import { QueryClient } from "@tanstack/react-query";

import { DAY, HOUR, MINUTE } from "~/constants";

export enum CacheUpdateFrequency {
  Always = 0,
  Never = Infinity,
  High = 5 * MINUTE,
  Medium = 1 * HOUR,
  Low = 1 * DAY,
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      gcTime: 24 * HOUR,
    },
  },
});
